import { createApp } from "vue";
import { createPinia } from "pinia"; // Add this import
import Search from "./components/Search.vue";

const mountApp = (el) => {
  const app = createApp();
  const pinia = createPinia(); // Create Pinia instance
  
  app.use(pinia); 
  app.component("search", Search);
  app.mount(el);

  return app;
};

document
  .querySelectorAll(".booking-aggregator-widget-container")
  .forEach((el) => {
    mountApp(el);
  });